import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FcGoogle } from "react-icons/fc";
import { useAuth } from "../../contexts/AuthContext";
import { Input, Button, TAP } from "../../components/ds";
import AuthLayout from "./AuthLayout";

// NOTE: DS-restyle only — all auth logic below (state, submit handler, Google
// SSO redirect, error/success messaging, post-login navigation) is unchanged
// from the pre-DS version. Only the markup/classes changed.
//
// NOTE: "Sign up" and "Forgot your password?" currently have no dedicated
// pages/routes of their own — sign-up happens on the landing page ("/", out
// of scope for this pass) and "/forgot-password" is not a registered route
// in App.js. Both links are left pointing exactly where they pointed before;
// AuthLayout is written so that whenever those pages are built, they can
// reuse it directly.

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const from = location.state?.from?.pathname || "/Overview";

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      setMessage("Login successful!");
      setTimeout(() => navigate(from), 1000);
    } catch (err) {
      setMessage(err.message || "Login failed");
    }
  };

  const handleGoogle = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
  };

  const isSuccess = message.includes("successful");

  return (
    <AuthLayout>
      <Button
        variant="secondary"
        size="lg"
        onClick={handleGoogle}
        style={{ width: "100%" }}
        as={motion.button}
        whileTap={TAP}
      >
        <FcGoogle size={18} />
        Sign in with Google
      </Button>

      <div className="ds-auth-divider">
        <span>or</span>
      </div>

      <form className="ds-auth-form" onSubmit={handleSubmit}>
        <Input
          id="email-address"
          name="email"
          type="email"
          label="Email address"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
        />

        <Input
          id="password"
          name="password"
          type="password"
          label="Password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
        />

        <div className="ds-auth-row">
          <Link to="/forgot-password" className="ds-auth-link">
            Forgot your password?
          </Link>
        </div>

        <Button
          type="submit"
          variant="accent"
          size="lg"
          style={{ width: "100%" }}
          as={motion.button}
          whileTap={TAP}
        >
          Sign in
        </Button>
      </form>

      {message && (
        <p className={`ds-auth-message ${isSuccess ? "is-success" : "is-error"}`}>
          {message}
        </p>
      )}

      <p className="ds-auth-links">
        Don't have an account? <Link to="/">Sign up</Link>
      </p>
    </AuthLayout>
  );
};

export default Login;
